import moment from "moment";
import Settings from "@/config.json";

class AutomaticInvoice {
    id = null;
    name = '';
    currency = '';
    discount = 0;
    amount = 0;
    footer = '';
    user_id = null;
    customer_id = null;
    invoice_sequence_id = null;
    items = [];
    ppo = false;
    locale = '';
    payment_method_id = null;
    iban = '';
    swift = '';
    ppo_text = '';
    document_format_id = 1;
    active = true;
    day = 1;
    month = 0;
    last_time_created = null;
    contract_id = null;

    constructor(data, validation = false) {
        this.currency = 'EUR';
        if (moment().format('YYYY-MM-DD HH:mm:ss') < Settings.EUR_TRANSITION) {
            this.currency = 'HRK';
        }

        for (const [key, value] of Object.entries(data)) {
            this[key] = value;
        }

        if (validation) {
            for (const [key] of Object.entries(this)) {
                this[key] = '';
            }
        }
    }

    Fill(data) {
        for (const [key] of Object.entries(this)) {
            if (data[key] !== undefined) {
                this[key] = data[key];
            }
        }
    }
}

export default AutomaticInvoice;
